import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=e8c1dfac&scoped=true"
import script from "./activation.vue?vue&type=script&lang=js"
export * from "./activation.vue?vue&type=script&lang=js"
import style0 from "./activation.vue?vue&type=style&index=0&id=e8c1dfac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1dfac",
  null
  
)

export default component.exports